
define('tpl!taoQtiItem/qtiRunner/tpl/inlineModalFeedbackDeliveryButton', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<li data-control=\"feedback-ok\" class=\"small btn-info action forward\" title=\"Feedback ok and ready to proceed.\">\n    <a class=\"li-inner\" href=\"#\">\n        <span class=\"icon-result-ok\"></span>\n        <span class=\"text\">OK</span>\n    </a>\n</li>";
  });
});

